export enum docType {
  project = 'project',
  video = 'video',
  asset = 'asset',
  note = 'note',
  record = 'record',
  audio = 'audio',
  gallery = 'gallery',
}

export enum firestoreCollection {
  projects = 'projects',
  users = 'users',
  notes = 'notes',
  records = 'records',
  videos = 'videos',
  assets = 'assets',
  audio = 'audio',
  gallery = 'gallery',
  projectDefaults = 'defaults',
}

export enum storageBucket {
  cobox_videos = 'cobox_videos',
  cobox_assets = 'cobox_assets',
  cobox_images = 'cobox_images',
  cobox_audio = 'cobox_audio',
  cobox_gallery = 'cobox_gallery',
}

/**
 * Where uploads go. Live uses one bucket per kind (gs://cobox_videos …). A dev build sets
 * REACT_APP_UPLOAD_BUCKET to the dev project's own bucket, and each kind becomes a folder in it,
 * so a dev build can never write to the live buckets.
 */
const devUploadBucket = process.env.REACT_APP_UPLOAD_BUCKET || '';
const bucketURL = (name: storageBucket) => (devUploadBucket ? `gs://${devUploadBucket}/${name}` : `gs://${name}`);

/** The bucket root a stored `fullPath` is relative to. */
export const bucketRoot = (name: storageBucket) => (devUploadBucket ? `gs://${devUploadBucket}` : `gs://${name}`);

export const storageBucketRef = {
  cobox_videos: bucketURL(storageBucket.cobox_videos),
  cobox_assets: bucketURL(storageBucket.cobox_assets),
  cobox_images: bucketURL(storageBucket.cobox_images),
  cobox_audio: bucketURL(storageBucket.cobox_audio),
  cobox_gallery: bucketURL(storageBucket.cobox_gallery),
};

export const variant = {
  button: {
    primary: 'primary',
    outlineOnWhite: 'outlineOnWhite',
    outlineOnGreen: 'outlineOnGreen',
  },
  forms: {
    inputOnPrimary: 'inputOnPrimary',
    inputField: 'inputField',
    inputFieldNoLine: 'inputFieldNoLine',
  },
  text: {
    error: 'error',
  },
  box: {
    line: 'line',
    title: 'title',
  },
};

export enum durationType {
  sec = 'sec',
  min = 'min',
  hour = 'hour',
}

export enum recordSort {
  keyNumber = 'keyNumber',
  title = 'title',
  duration = 'duration',
  date = 'date',
}

export enum videoSort {
  filename = 'fileName',
  date = 'date',
  size = 'size',
  ext = 'ext',
  category = 'category',
}

export enum fileSort {
  filename = 'filename',
  ext = 'ext',
  date = 'date',
  size = 'size',
}

export enum assetSort {
  filename = 'fileName',
  date = 'date',
  size = 'size',
}

export enum gallerySort {
  filename = 'fileName',
  date = 'date',
  size = 'size',
}
